import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    version: "",
    dbid: "",       //acc_key
    corpname: "",
    corpkey: "",    //acc_id
    account: "",
    name: "",
    authority: "",
    role: "",
    staff: "",
    accctl: [],
    debug: false,
    loginkey:""
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
       logininfo: (state, action) => {
            return Object.assign({}, state, {
                version: action.payload.version, corpname: action.payload.corpname, corpkey: action.payload.corpkey, dbid: action.payload.dbid,
                debug: action.payload.debug, loginkey: action.payload.loginkey
            })
       },
       signinfo: (state, action) => {
            return Object.assign({}, state, {
                account: action.payload.account, name: action.payload.name, authority: action.payload.authority,
                role: action.payload.role, staff: action.payload.staff, accctl:action.payload.accctl
            })
        },
        continueinfo: (state, action) => {
            return action.payload;
        },
        resetuser: (state, action) => {
            return initialState;
        },
        resetlogin: (state, action) => {
            return Object.assign({}, state, {
                corpname: "", corpkey: "", loginkey: ""
            })
        },
    },
});

export const {
    logininfo, signinfo, continueinfo, resetuser, resetlogin
} = userSlice.actions

export default userSlice;
